import { Component, Input, OnInit, inject } from "@angular/core";
import { BusinessNavigatorDetailModel } from "@app/navigators/business-navigator/models/business-navigator-detail-model";
import { BusinessNavigatorRequestModel } from "@app/navigators/business-navigator/models/business-navigator-request-model";
import { BusinessNavigatorDataService } from "@app/navigators/business-navigator/services/business-navigator-data.service";
import { DateFormatPipe } from "@app/shared/pipes/date-format.pipe";

@Component({
    selector: "business-details",
    templateUrl: "./business-details.component.html",
    imports: [DateFormatPipe],
})
export class BusinessDetailsComponent implements OnInit {
    private dataService = inject(BusinessNavigatorDataService);

    @Input() requestModel: BusinessNavigatorRequestModel;

    detailModel: BusinessNavigatorDetailModel;

    ngOnInit() {
        this.dataService.getDetails(this.requestModel).then((details) => {
            this.detailModel = details;
        });
    }
}
